import gql from "graphql-tag";

export const fragmentUser = gql`
  fragment User on User {
    id
    email
    firstName
    lastName
    mfaRemainingGraceDays
    mfaSetupDate
    isMfaEnabled
    defaultMfaMethod
    userPermissions {
      code
      name
    }
    avatar {
      url
    }
    businessDetails {
      id
      status
    }
    permissionGroups {
      name
      smopUsertypeCode
      mfaEnabledDate
      mfaRemainingGraceDays
    }
    accessGroup {
      name
      smopUsertypeCode
      accesses {
        objectId
        privateObjectId
        accessType
        description
        storeType
      }
    }
    status
    contactNo
    promoCreator
  }
`;
